document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-lp202601]');
  const fixed = document.querySelector('[data-lp-fixed]');
  if (!root || !fixed) return;

  const blocks = Array.from(root.querySelectorAll('[data-lp-block]'));

  const targets = blocks.filter((el) => {
    const idx = el.getAttribute('data-lp-index');
    return (
      idx === '2' ||
      idx === '3' ||
      idx === '4' ||
      idx === '5' ||
      idx === '5-1' ||
      idx === '5-2' ||
      idx === '5-3' ||
      idx === '6' ||
      idx === '7' ||
      idx === '8' ||
      idx === '9'
    );
  });

  if (targets.length === 0) return;

  const visibleSet = new Set();
  let timer = null;

  const apply = () => {
    if (visibleSet.size > 0) {
      fixed.classList.add('is-show');
    } else {
      fixed.classList.remove('is-show');
    }
  };

  const scheduleApply = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(apply, 120);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleSet.add(entry.target);
        } else {
          visibleSet.delete(entry.target);
        }
      });
      scheduleApply();
    },
    {
      root: null,
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0
    }
  );

  targets.forEach((el) => io.observe(el));

  fixed.classList.remove('is-show');
});